import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Notification } from '@models/release-notes/notification';

@Component({
  selector: 'app-dropdown-notifications',
  templateUrl: './dropdown-notifications.component.html',
  styleUrls: ['./dropdown-notifications.component.scss']
})
export class DropdownNotificationsComponent implements OnInit {
  @Input() notifications: Notification[];
  @Output() triggerToggleDropdown = new EventEmitter<boolean>();

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  releaseNotesRoute() {
    this.router.navigate(['/release-notes']);
    this.triggerToggleDropdown.emit();
  }
}
